import { render, staticRenderFns } from "./change-center.vue?vue&type=template&id=4451e94e&scoped=true"
import script from "./change-center.vue?vue&type=script&lang=js"
export * from "./change-center.vue?vue&type=script&lang=js"
import style0 from "./change-center.vue?vue&type=style&index=0&id=4451e94e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4451e94e",
  null
  
)

export default component.exports